import { useEffect, useState } from "react";
import { FiActivity } from "react-icons/fi";
import bankService from "../../../services/bank.service";
import PaginationBar from "../../../components/common/PaginationBar";
import { PAGE_LIMIT } from "../../../constants/pagination";
import { readPagination } from "../../../utils/listPagination";
import "../../../styles/users.css";

export default function BankTracing() {
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 0, total: 0 });

  useEffect(() => {
    setLoading(true);
    bankService.getTracingView({ page, limit: PAGE_LIMIT })
      .then((res) => {
        setAgencies(res?.data?.data?.agencies || []);
        setPagination(readPagination(res?.data));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <div className="page">
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
        <FiActivity size={22} />
        <h2>Linked Agencies — Who is using my data?</h2>
      </div>

      {loading ? (
        <p className="muted">Loading...</p>
      ) : agencies.length === 0 ? (
        <div style={{ padding: 32, textAlign: "center", color: "var(--muted,#6b7280)" }}>
          <FiActivity size={40} style={{ opacity: 0.3 }} />
          <p style={{ marginTop: 12 }}>No agencies linked to your data yet.</p>
          <p style={{ fontSize: 13 }}>SSDI will connect agencies to your account.</p>
        </div>
      ) : (
        <div className="company-table-wrap">
          <table className="users-table excel-grid-table">
            <thead>
              <tr>
                <th>Agency</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Address</th>
                <th>Pincode</th>
                <th>Referred by</th>
              </tr>
            </thead>
            <tbody>
              {agencies.map((agency, idx) => {
                const ra = agency.repoAdmin || {};
                return (
                  <tr key={ra._id || ra.id || idx}>
                    <td>{ra.name || ra.email || "Agency"}</td>
                    <td>{ra.email || "—"}</td>
                    <td>{ra.phone || "—"}</td>
                    <td>{ra.address || ra.companyId?.address || "—"}</td>
                    <td>{ra.pincode || "—"}</td>
                    <td>{agency.banker?.name || agency.banker?.email || "—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <PaginationBar
        page={pagination.page || page}
        totalPages={pagination.totalPages}
        total={pagination.total}
        loading={loading}
        onPageChange={setPage}
      />
    </div>
  );
}
